// extracted by mini-css-extract-plugin
export default {"container":"DemoAuth_container__1P2rJ","emailField":"DemoAuth_emailField__aroTK","form":"DemoAuth_form__LJ-iS","logo":"DemoAuth_logo__tyIrY","button":"DemoAuth_button__NBA+x"};